import * as S from './styles';
import { useMemo, useEffect, useRef } from 'react';
import { colors } from '@/constants';
import { packingTypes } from '@/shared';
import { ProductProps, PackagesTypesProps, PackagingProductProps } from '@/types';
import { useCart } from '@/hooks';

interface Product {
  size?: number;
  showQtd?: boolean;
  product: ProductProps;
  pack: PackagesTypesProps;
  packQty: number;
  setPackage: (val: PackagesTypesProps) => void;
  setPackQuantity: (val: number) => void;
  autoSelectFirst?: boolean;
  canDisablePack?: boolean;
  fullBorder?: boolean;
}

const RenderPackaging = ({
  pack,
  size,
  product,
  showQtd,
  packQty,
  setPackage,
  setPackQuantity,
  autoSelectFirst = true,
  canDisablePack = true,
  fullBorder = false,
}: Product) => {
  console.log({ product, pack, packQty });

  const { getLimit } = useCart();
  const firstEmbSelected = useRef(false);

  const list = useMemo(() => {
    const deepCpyEmbs = structuredClone(product?.EMBALAGEM);
    if (!deepCpyEmbs?.length) return [{ SG_EMBALAGEM: 'UN' }];

    const orderedList = deepCpyEmbs.sort((a, b) => {
      const aQtd = (a.QTD_MULTIPLO_VENDA || 1) * (a.QTD_EMBALAGEM || 1);
      const bQty = (b.QTD_MULTIPLO_VENDA || 1) * (b.QTD_EMBALAGEM || 1);
      return aQtd < bQty ? 1 : -1;
    });
    return orderedList;
  }, [product.EMBALAGEM]) as PackagingProductProps[];

  // useEffect(() => {
  //   if (list && list.length > 0 && list[0]?.SG_EMBALAGEM != pack && !firstEmbSelected.current && autoSelectFirst) {
  //     firstEmbSelected.current = true;
  //     setPackage(list[0]?.SG_EMBALAGEM);
  //     setPackQuantity(list[0]?.QTD_MULTIPLO_VENDA > 1 ? list[0]?.QTD_MULTIPLO_VENDA : list[0]?.QTD_EMBALAGEM);
  //   }
  // }, [list]);

  const limit = getLimit(product?.COD_PRODUTO);

  return (
    <>
      <S.Row>
        {/* Rever esse map */}
        {list.map((embalagem) => {
          const packing = packingTypes?.[embalagem?.SG_EMBALAGEM];

          const qty = embalagem?.QTD_MULTIPLO_VENDA > 1 ? embalagem?.QTD_MULTIPLO_VENDA : embalagem?.QTD_EMBALAGEM;

          const isActive =
            pack === 'PK'
              ? embalagem?.QTD_MULTIPLO_VENDA > 1 && embalagem?.QTD_MULTIPLO_VENDA === packQty && pack === embalagem?.SG_EMBALAGEM
              : embalagem?.SG_EMBALAGEM === pack && embalagem?.QTD_EMBALAGEM === packQty;
          const hasPrice = product?.PRECO?.find((p) => p?.SG_EMBALAGEM === packing?.shortName);
          const isDisabled = canDisablePack && (limit < qty || !hasPrice);

          return (
            <S.BoxEmbalagem
              size={size}
              $fullBorder={fullBorder}
              $isactive={isActive}
              $unityPack={list.length === 1}
              onClick={() => {
                if (isDisabled) return;

                setPackage(packing?.shortName);
                setPackQuantity(qty);
              }}
              key={`pack-${product.COD_PRODUTO}-${packing?.shortName}`}
              data-test={`pack-${product.COD_PRODUTO}-${packing?.shortName}`}
            >
              <S.PackImage src={packing?.icon} alt="" />
              {isActive && <S.CheckFill size={24} color={colors.alert.green110} />}

              <S.BoxLabel>
                <S.BoxQtdEmbalagem>
                  <S.QtdEmbalagem>{qty}/un</S.QtdEmbalagem>
                </S.BoxQtdEmbalagem>
              </S.BoxLabel>
            </S.BoxEmbalagem>
          );
        })}
      </S.Row>
    </>
  );
};

export default RenderPackaging;
